"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Android_1 = __importDefault(require("../Icons/Android"));
var Apple_1 = __importDefault(require("../Icons/Apple"));
var config = {
    columns: [
        {
            items: [
                {
                    linkProps: {
                        href: '//www.veepee.es/Vp4/Help/question.ashx?cypher=sHXzetg9Rqs7CucETJL7CA%3D%3D'
                    },
                    text: '¿Quiénes somos?'
                },
                {
                    linkProps: {
                        href: '//www.veepee.es/vp4/help/Question.ashx?cypher=azoc8YfN%2Beq%2BTt%2F2LjHOZQ%3D%3D'
                    },
                    text: 'Contáctanos'
                },
                {
                    linkProps: {
                        href: '//www.veepee.es/Vp4/Help/question.ashx?cypher=uaPdOVZFkv2DqVaFQvczTQ%3D%3D'
                    },
                    text: 'La seguridad'
                },
                {
                    linkProps: {
                        href: '//www.veepee.es/vp4/Help/Answer.aspx?cypher=rb6qWA7X9i0wEjgcQQ%2F0Z%2BMN95MIxbodDIiigpPkgRbBirpi6WPxQnRhqsvJJOdnevKS4WgsLn8CsJ6wES1CNVcGu6tiiMfsSQPFkZcC%2FxHfuqNPh1GeBKokJJee7mQlPjALbCb6Fu5RWcaEJP%2FEHBLO7WTIpHbfCV3Kp58NoypTQnoBfZePCsgbCPj1NcqQIrqKbA3kbe9Gzxz2sMIOpg%3D%3D'
                    },
                    text: 'Menciones legales'
                }
            ],
            title: 'Ayuda y contacto'
        },
        {
            items: [
                {
                    linkProps: {
                        href: '//www.veepee.es/cgv/es-ES/Condiciones_Generales_de_Venta_y_Utilizacion.pdf',
                        target: '_blank'
                    },
                    text: 'Condiciones generales de uso de Viajes'
                },
                {
                    linkProps: {
                        href: '//www.veepee.es/ns/es-es/legal/privacy'
                    },
                    text: 'Protección de los datos personales'
                },
                {
                    linkProps: {
                        href: '//www.veepee.es/vp4/Help/Answer.aspx?cypher=Ckalk9yFmH5AigqvTLT%2F%2BA%3D%3D'
                    },
                    text: 'Mediación'
                }
            ],
            title: 'Condiciones Generales'
        },
        {
            items: [
                {
                    linkProps: {
                        href: '//careers.veepee.com/vptech-2/',
                        target: '_blank'
                    },
                    text: 'vpTech'
                },
                {
                    linkProps: {
                        href: '//careers.veepee.com/en/home-page-en',
                        target: '_blank'
                    },
                    text: 'Veepee'
                }
            ],
            title: 'Join us'
        },
        {
            items: [],
            title: ''
        }
    ],
    country: 'ES',
    flag: 'ES',
    header: {
        apps: {
            items: [
                {
                    icon: Apple_1.default,
                    label: 'iOS',
                    linkProps: {
                        href: '//apps.apple.com/es/app/veepee-by-vente-privee/id906681058',
                        target: '_blank'
                    }
                },
                {
                    icon: Android_1.default,
                    label: 'Android',
                    linkProps: {
                        href: '//play.google.com/store/apps/details?id=com.venteprivee',
                        target: '_blank'
                    }
                }
            ],
            title: 'Nuestras aplicaciones'
        },
        social: []
    },
    lang: 'es',
    logoSubtitle: 'VP, grandes marcas a precios bajos'
};
exports.default = config;
